import type { CellContext } from '@tanstack/react-table'
import { EditIcon, Trash2Icon } from 'lucide-react'

import {
  ContextMenu,
  ContextMenuContent,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuTrigger,
  Link,
} from '@/components/ui'
import {
  DeleteDocumentsDialog,
  type Document,
  ProcessDocumentsButton,
} from '@/modules/documents'
import {
  hasDocumentFailed,
  isDocumentProcessing,
} from '@/modules/documents/status'
import { useDialogActions } from '@/stores/dialog'
import { getDocumentPath } from '@/utils'
import { EditDocumentDialog } from '../../dialogs/EditDocumentDialog'

export const DocumentCell = (cell: CellContext<Document, string>) => {
  const { openDialog } = useDialogActions()
  const document = cell.row.original
  const fileName = cell.getValue()
  const fileUrl = document.fileUrl
  const isProcessing = isDocumentProcessing(document)

  if (fileUrl) {
    return (
      <ContextMenu>
        <ContextMenuTrigger asChild>
          <Link
            to={getDocumentPath(document)}
            className="flex items-center min-w-0 text-sm size-full cursor-context-menu"
          >
            <span className="truncate">{fileName}</span>
          </Link>
        </ContextMenuTrigger>
        <ContextMenuContent>
          <ContextMenuItem
            onClick={() => openDialog(EditDocumentDialog.id, document)}
          >
            <EditIcon className="size-4" />
            Change folder
          </ContextMenuItem>
          <ContextMenuItem asChild>
            <ProcessDocumentsButton
              theme="ghost"
              table={cell.table}
              documentsToProcess={[document]}
            >
              {hasDocumentFailed(document) ? 'Retry' : 'Process'} document
            </ProcessDocumentsButton>
          </ContextMenuItem>
          <ContextMenuSeparator />
          <ContextMenuItem
            onClick={() => openDialog(DeleteDocumentsDialog.id, [document])}
            destructive
            disabled={isProcessing}
          >
            <Trash2Icon className="h-4 w-4" />
            Delete document
          </ContextMenuItem>
        </ContextMenuContent>
      </ContextMenu>
    )
  }

  return <span className="block truncate text-sm">{fileName}</span>
}
